import * as React from 'react';

const NotFoundIllustration = React.memo((): React.ReactElement => {
  return (
    <svg
      width="480"
      height="280"
      viewBox="0 0 480 280"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="not-found-illustration"
    >
      <path
        d="M238.908 148.98H157.214C152.725 148.975 149.087 145.329 149.082 140.83V98.3536C149.087 93.8549 152.725 90.2092 157.214 90.2041H238.908C243.398 90.2092 247.036 93.8549 247.041 98.3536V140.83C247.036 145.329 243.398 148.975 238.908 148.98Z"
        fill="#E6E8E9"
      />
      <path
        d="M345.847 148.98H264.153C259.664 148.975 256.026 145.329 256.021 140.83V98.3536C256.026 93.8549 259.664 90.2092 264.153 90.2041H345.847C350.337 90.2092 353.975 93.8549 353.98 98.3536V140.83C353.975 145.329 350.337 148.975 345.847 148.98Z"
        fill="#E6E8E9"
      />
      <path
        d="M247.041 219.184H149.082V165.267C149.087 160.782 152.725 157.148 157.214 157.143H238.908C243.398 157.148 247.036 160.782 247.041 165.267V219.184Z"
        fill="#E6E8E9"
      />
      <path
        d="M353.98 219.184H256.021V165.267C256.026 160.782 259.664 157.148 264.153 157.143H345.847C350.337 157.148 353.975 160.782 353.98 165.267V219.184Z"
        fill="#E6E8E9"
      />
      <path
        d="M345.847 82.0408H264.153C259.664 82.0357 256.026 78.4013 256.021 73.9164V28.1244C256.026 23.6395 259.664 20.0051 264.153 20H345.847C350.337 20.0051 353.975 23.6395 353.98 28.1244V73.9164C353.975 78.4013 350.337 82.0357 345.847 82.0408Z"
        fill="#E6E8E9"
      />
      <path
        d="M238.908 82.0408H157.214C152.725 82.0357 149.087 78.4013 149.082 73.9164V28.1244C149.087 23.6395 152.725 20.0051 157.214 20H238.908C243.398 20.0051 247.036 23.6395 247.041 28.1244V73.9164C247.036 78.4013 243.398 82.0357 238.908 82.0408Z"
        fill="#E6E8E9"
      />
      <path
        d="M350.952 221.633H153.742C151.168 221.633 149.082 219.623 149.082 217.143C149.082 214.663 151.168 212.653 153.742 212.653H350.952C353.526 212.653 355.612 214.663 355.612 217.143C355.612 219.623 353.526 221.633 350.952 221.633Z"
        fill="#D2D5D7"
      />
      <path
        d="M243.776 216.735H162.959V198.122C162.959 175.941 181.051 157.959 203.367 157.959C225.684 157.959 243.776 175.941 243.776 198.122V216.735Z"
        fill="#D2D5D7"
      />
      <path
        d="M340.102 216.735H259.286V198.122C259.286 175.941 277.377 157.959 299.694 157.959C322.011 157.959 340.102 175.941 340.102 198.122V216.735Z"
        fill="#D2D5D7"
      />
      <rect
        x="302.551"
        y="260"
        width="6.53061"
        height="41.6327"
        transform="rotate(-180 302.551 260)"
        fill="#D2D5D7"
      />
      <path
        d="M278.061 259.606C278.061 260.294 287.747 259.872 299.694 259.872C311.641 259.872 321.327 260.294 321.327 259.606C321.327 258.919 311.641 253.469 299.694 253.469C287.747 253.469 278.061 258.919 278.061 259.606Z"
        fill="#D2D5D7"
      />
      <rect
        x="206.225"
        y="260"
        width="6.53061"
        height="41.6327"
        transform="rotate(-180 206.225 260)"
        fill="#D2D5D7"
      />
      <path
        d="M181.735 259.606C181.735 260.294 191.42 259.872 203.367 259.872C215.315 259.872 225 260.294 225 259.606C225 258.919 215.315 253.469 203.367 253.469C191.42 253.469 181.735 258.919 181.735 259.606Z"
        fill="#D2D5D7"
      />
      <path
        d="M146.739 171.837H132.684C131.822 171.837 131.123 172.531 131.123 173.388V202.857H133.465V175.714C133.465 174.858 134.164 174.163 135.027 174.163H145.178C146.04 174.163 146.739 174.858 146.739 175.714V202.857H149.082V173.388C149.082 172.531 148.383 171.837 147.52 171.837H146.739Z"
        fill="#040B2B"
      />
      <path
        d="M155.551 260H122.204C118.565 259.996 115.616 257.047 115.612 253.408V204.551C115.616 200.912 118.565 197.963 122.204 197.959H155.551C159.19 197.963 162.139 200.912 162.143 204.551V253.408C162.139 257.047 159.19 259.996 155.551 260Z"
        fill="#040B2B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M112.347 228.98C112.347 233.333 113.634 237.959 116.02 237.959C118.406 237.959 119.694 233.333 119.694 228.98C119.694 224.626 118.406 220 116.02 220C113.634 220 112.347 224.626 112.347 228.98ZM113.163 228.98C113.163 224.138 114.669 220.764 116.02 220.764C117.372 220.764 118.878 224.138 118.878 228.98C118.878 233.821 117.372 237.195 116.02 237.195C114.669 237.195 113.163 233.821 113.163 228.98Z"
        fill="#040B2B"
      />
      <path
        d="M153.728 230.612H147.7C146.66 230.611 145.818 229.781 145.816 228.757V224.304C145.818 223.28 146.66 222.45 147.7 222.449H153.728C154.768 222.45 155.611 223.28 155.612 224.304V228.757C155.611 229.781 154.768 230.611 153.728 230.612Z"
        fill="white"
      />
      <path
        d="M155.659 256.735H120.464C120.039 256.735 119.694 256.388 119.694 255.961V201.998C119.694 201.571 120.039 201.225 120.464 201.225H155.659C156.084 201.225 156.429 201.571 156.429 201.998C156.429 202.425 156.084 202.772 155.659 202.772H121.234V255.188H155.659C156.083 255.189 156.427 255.535 156.427 255.961C156.427 256.388 156.083 256.734 155.659 256.735Z"
        fill="white"
      />
      <path
        d="M342.988 111.146C342.528 110.752 341.996 110.452 341.42 110.262C340.133 109.866 338.781 109.721 337.438 109.832C336.453 109.887 335.474 110.023 334.511 110.237L289.55 122.855C288.7 123.092 287.865 123.368 287.045 123.682C284.147 122.557 275.953 119.302 275.055 118.134L271.531 119.157L277.406 127.856C277.101 127.988 276.91 128.292 276.923 128.621C276.937 128.95 277.152 129.237 277.466 129.344C284.24 131.651 294.469 128.588 294.469 128.588L333.756 117.453C333.756 117.453 345.614 113.474 342.988 111.146Z"
        fill="white"
      />
      <path
        d="M321.326 117.959L295.891 124.773L294.388 127.755L321.326 117.959Z"
        fill="#E6E8E9"
      />
      <path
        d="M374.713 260.184H105.491C105.22 260.184 105 259.96 105 259.684C105 259.407 105.22 259.184 105.491 259.184H374.713C374.984 259.184 375.204 259.407 375.204 259.684C375.204 259.96 374.984 260.184 374.713 260.184Z"
        fill="#181C1E"
      />
      <path
        d="M320.391 63.2654C318.321 63.2649 316.345 64.1128 314.937 65.6054C313.252 64.9459 311.344 65.1516 309.844 66.1547C308.344 67.1578 307.447 68.8276 307.449 70.6123H327.857C327.857 66.5547 324.514 63.2654 320.391 63.2654Z"
        fill="white"
      />
      <path
        d="M212.636 39.5918C210.566 39.5913 208.59 40.4392 207.182 41.9318C205.497 41.2723 203.589 41.4781 202.089 42.4811C200.588 43.4842 199.691 45.154 199.694 46.9387H220.102C220.102 42.8811 216.759 39.5918 212.636 39.5918V39.5918Z"
        fill="white"
      />
      <path
        d="M179.166 104.082C177.097 104.081 175.121 104.929 173.713 106.422C172.028 105.762 170.12 105.968 168.619 106.971C167.119 107.974 166.222 109.644 166.225 111.428H186.633C186.633 109.48 185.846 107.611 184.446 106.233C183.046 104.856 181.147 104.082 179.166 104.082Z"
        fill="white"
      />
      <path
        d="M231.532 254.286H237.616L240.51 231.429H231.531L231.532 254.286Z"
        fill="#A0616A"
      />
      <path
        d="M249.605 259.883L230.675 259.884L230.675 252.57L242.291 252.57C244.231 252.57 246.091 253.34 247.463 254.712C248.835 256.083 249.605 257.944 249.605 259.883L249.605 259.883Z"
        fill="#202528"
      />
      <path
        d="M241.132 251.021L247.041 249.242L242.701 226.531L233.98 229.156L241.132 251.021Z"
        fill="#A0616A"
      />
      <path
        d="M259.873 250.984L241.811 256.652L239.621 249.674L250.705 246.196C254.559 244.986 258.664 247.13 259.873 250.984L259.873 250.984Z"
        fill="#202528"
      />
      <path
        d="M237.491 240.605L226.439 211.441C223.959 212.026 203.165 216.652 196.2 209.198C193.814 206.643 193.348 202.941 194.817 198.196L198.881 193.061L199.008 193.068C200.544 193.149 236.675 195.185 239.152 206.141C241.241 215.377 245.054 232.598 246.173 237.656C246.408 238.739 245.818 239.831 244.787 240.224L240.342 241.899C240.094 241.993 239.832 242.041 239.567 242.041C238.646 242.041 237.821 241.47 237.491 240.605Z"
        fill="#040B2B"
      />
      <path
        d="M230.96 243.871L219.908 214.706C217.428 215.292 196.634 219.917 189.67 212.463C187.283 209.908 186.817 206.207 188.286 201.461L192.351 196.327L192.477 196.333C194.014 196.415 230.145 198.45 232.622 209.406C234.71 218.643 238.524 235.863 239.643 240.921C239.877 242.004 239.287 243.097 238.256 243.489L233.811 245.165C233.564 245.258 233.301 245.306 233.036 245.306C232.115 245.306 231.29 244.735 230.96 243.871Z"
        fill="#040B2B"
      />
      <path
        d="M221.038 187.347C217.73 187.346 214.667 185.596 212.974 182.741L209.49 176.812L217.772 172.264L221.288 177.108L245.147 174.583C245.263 174.372 245.394 174.169 245.538 173.976C246.464 172.752 247.865 171.981 249.39 171.856C250.922 171.724 252.437 172.264 253.544 173.337C255.351 175.077 255.728 177.837 254.454 180.002C253.671 181.327 252.363 182.254 250.858 182.55C249.353 182.845 247.794 182.482 246.572 181.551C246.432 181.443 246.297 181.328 246.169 181.207L223.317 187.06C222.572 187.251 221.807 187.347 221.038 187.347Z"
        fill="#A0616A"
      />
      <path
        d="M187.841 203.25C187.163 202.76 186.817 201.931 186.945 201.104C188.316 192.052 186.738 179.085 185.174 169.801C184.524 165.981 185.719 162.079 188.396 159.281C191.073 156.483 194.915 155.12 198.754 155.607C200.401 155.825 202.032 156.147 203.638 156.572C209.134 157.958 212.937 162.972 212.795 168.646C212.561 177.605 214.377 188.783 215.169 193.173C215.278 193.783 215.129 194.41 214.758 194.905C214.394 195.396 213.84 195.709 213.233 195.769C204.458 196.666 194.995 200.952 190.135 203.426C189.823 203.588 189.477 203.672 189.125 203.674C188.663 203.672 188.213 203.524 187.841 203.25Z"
        fill="#2969F2"
      />
      <path
        d="M211.81 179.844C211.277 179.631 210.85 179.209 210.624 178.672L205.864 167.453C205.079 165.609 205.32 163.478 206.494 161.864C207.668 160.25 209.598 159.398 211.555 159.629C213.512 159.861 215.2 161.14 215.981 162.986L220.741 174.205C221.213 175.32 220.711 176.614 219.619 177.098L213.46 179.818C212.936 180.051 212.341 180.061 211.81 179.844L211.81 179.844Z"
        fill="#2969F2"
      />
      <circle cx="198.061" cy="140" r="12.2449" fill="#A0616A" />
      <path
        d="M191.198 150.75C190.853 151.151 190.362 151.395 189.835 151.425C189.309 151.456 188.793 151.27 188.405 150.912C185.716 148.718 183.584 145.912 182.184 142.724C180.616 138.959 180.386 134.364 182.17 130.835C183.678 127.851 186.386 125.952 189.088 124.399C190.125 123.742 191.26 123.258 192.45 122.968C193.666 122.689 194.942 122.942 195.962 123.664C197.054 124.5 197.597 125.876 197.375 127.239C198.611 125.598 200.278 124.337 202.187 123.6C203.359 123.091 204.667 123.003 205.896 123.349C207.631 123.933 208.916 125.699 209.631 127.597C210.209 129.05 210.421 130.625 210.247 132.18C210.094 133.681 209.337 135.053 208.152 135.975C206.736 136.96 204.912 136.86 203.265 136.424C201.619 135.988 200.021 135.25 198.346 135.044C196.67 134.838 194.814 135.284 193.816 136.79C193.113 137.85 192.947 139.247 192.804 140.579L192.058 147.504C192.005 148.495 191.793 149.471 191.43 150.393C191.369 150.522 191.291 150.642 191.198 150.75Z"
        fill="#040B2B"
      />
      <path
        d="M217.021 200.102C215.578 199.596 214.417 198.498 213.829 197.081C213.761 196.917 213.703 196.751 213.653 196.581L188.087 189.273C185.831 188.619 184.27 186.556 184.246 184.198L184.184 174.286L193.607 174.539L194.222 180.493L216.083 190.349C216.289 190.226 216.503 190.117 216.724 190.023H216.724C218.938 189.091 221.5 189.745 223.002 191.626C224.504 193.508 224.582 196.161 223.194 198.129C221.805 200.096 219.287 200.901 217.021 200.102L217.021 200.102Z"
        fill="#A0616A"
      />
      <path
        d="M183.931 178.828C183.535 178.388 183.334 177.809 183.372 177.222L184.138 164.922C184.261 162.898 185.469 161.093 187.307 160.188C189.145 159.283 191.332 159.416 193.044 160.536C194.755 161.657 195.73 163.595 195.601 165.618L194.835 177.918C194.757 179.14 193.692 180.069 192.454 179.996L185.477 179.572C184.882 179.538 184.325 179.27 183.931 178.828H183.931Z"
        fill="#2969F2"
      />
      <path
        d="M251.305 184.898H244.409C243.951 184.899 243.567 184.557 243.523 184.108L242.143 170.204H253.572L252.191 184.108C252.148 184.557 251.764 184.899 251.305 184.898Z"
        fill="#F55C38"
      />
      <path
        d="M253.505 171.837H242.209C241.722 171.836 241.327 171.421 241.327 170.909V168.683C241.327 168.171 241.722 167.756 242.209 167.755H253.505C253.993 167.756 254.387 168.171 254.388 168.683V170.909C254.387 171.421 253.993 171.836 253.505 171.837Z"
        fill="#181C1E"
      />
    </svg>
  );
});

NotFoundIllustration.displayName = 'NotFoundIllustration';

export { NotFoundIllustration };
